export default __webpack_public_path__ + "static/media/staq-io.07de6623.svg";